import useAuth from 'app/hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();

  // console.log("Here even if the session is expired, returns ", isAuthenticated)
  if (isAuthenticated) return <>{children}</>;
  return <Navigate replace to="/signin" state={{ from: pathname }} />;
};

export default AuthGuard;